import { useContext } from "react"
import { useAppSelector } from "hooks/redux"
import { KELLY_LINK_TYPES, KellyLinkContext } from "../kelly-link-types"
import { selectSurfaceView } from "../store/agent-chat-slice"
import type { ChatSurfaceView } from "../store/agent-chat-slice"

export type BodySurface = "artifacts" | "workflows" | "chat"

export function resolveBodySurface(surfaceView: ChatSurfaceView, isWorkflowsEnabled: boolean): BodySurface {
  if (surfaceView === "artifacts") return "artifacts"
  if (surfaceView === "workflows" && isWorkflowsEnabled) return "workflows"
  return "chat"
}

// Full screen reads the view off the address; a dock has no address of its own and keeps the Redux view.
export function useSurfaceView(isFull: boolean): ChatSurfaceView {
  const { link } = useContext(KellyLinkContext)
  const surfaceView = useAppSelector(selectSurfaceView)
  if (!isFull || link == null) return surfaceView
  return link.type == null ? "conversation" : KELLY_LINK_TYPES[link.type].surfaceView
}
